"use client";

import { usePathname } from "@/lib/router-compat";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { ReactNode, useEffect, useRef } from "react";

interface PageTransitionLayoutProps {
  children: ReactNode;
}

export function PageTransitionLayout({ children }: PageTransitionLayoutProps) {
  const pathname = usePathname();
  const pageRef = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();

  useEffect(() => {
    pageRef.current?.parentElement?.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  const focusPageHeading = () => {
    const heading =
      document.querySelector<HTMLElement>("main#main-content > header h1") ??
      pageRef.current?.querySelector<HTMLElement>("[data-page-heading]");
    if (!heading) return;
    heading.tabIndex = -1;
    heading.focus({ preventScroll: true });
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        ref={pageRef}
        key={pathname}
        className="h-full min-h-0"
        initial={shouldReduceMotion ? false : { opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: shouldReduceMotion ? 0 : 0.15 }}
        onAnimationComplete={focusPageHeading}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
